/** The seedable PRNG used by deterministic clients and test servers. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function seedFrom(value: string | number): number {
  if (String(value).trim() !== '' && Number.isFinite(Number(value))) return Number(value) >>> 0;
  let h = 0x811c9dc5;
  for (const c of String(value)) h = Math.imul(h ^ c.charCodeAt(0), 0x01000193);
  return h >>> 0;
}

export function seededStream(seed: number, name: string): () => number {
  return mulberry32(seed ^ seedFrom(name));
}
